// extracted by mini-css-extract-plugin
export var externalLink = "_bc-0";
export var internalLinkLabel = "_bc-1";